module.exports = __webpack_public_path__ + "static/img/0003.cf5315c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0003.png
// module id = t1QK
// module chunks = 1